import { createApiAction } from '@saucelabs/sl-util-redux';

import * as types from './types';
import * as api from './api';

export const getSauceConnectDownloadLinks = createApiAction(
  types.GET_SAUCE_CONNECT_DOWNLOAD_LINKS,
  () => api.getDownloadLinks(),
);
